import { render, staticRenderFns } from "./FormTiket.vue?vue&type=template&id=6f935327&"
import script from "./FormTiket.vue?vue&type=script&lang=js&"
export * from "./FormTiket.vue?vue&type=script&lang=js&"
import style0 from "./FormTiket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports